import { ModuleWithProviders, NgModule } from '@angular/core';

import { ASYNC_JOB_CONFIG_TOKEN } from '@recruitee/async-job';

import { BulkCompaniesCreateInvitationsAsyncJob } from './configs/create-invitations';
import { BulkCompaniesDeleteInvitationAsyncJob } from './configs/delete-invitation';
import { BulkCompaniesDeleteMembershipAsyncJob } from './configs/delete-membership';
import { BulkEEODataRequestAsyncJob } from './configs/eeo-data-request';
import { GenerateSampleDataAsyncJob } from './configs/generate-sample-data';
import { RemoveSampleDataAsyncJob } from './configs/remove-sample-data';
import { BulkResendEEODataRequestAsyncJob } from './configs/resend-eeo-data-request';
import { BulkCompaniesResendInvitationAsyncJob } from './configs/resend-invitation';

@NgModule()
export class CompanyAsyncJobsModule {
  public static forRoot(): ModuleWithProviders<CompanyAsyncJobsModule> {
    return {
      ngModule: CompanyAsyncJobsModule,
      providers: [
        {
          provide: ASYNC_JOB_CONFIG_TOKEN,
          useClass: BulkCompaniesDeleteMembershipAsyncJob,
          multi: true,
        },
        {
          provide: ASYNC_JOB_CONFIG_TOKEN,
          useClass: BulkCompaniesDeleteInvitationAsyncJob,
          multi: true,
        },
        {
          provide: ASYNC_JOB_CONFIG_TOKEN,
          useClass: BulkCompaniesResendInvitationAsyncJob,
          multi: true,
        },
        {
          provide: ASYNC_JOB_CONFIG_TOKEN,
          useClass: BulkResendEEODataRequestAsyncJob,
          multi: true,
        },
        { provide: ASYNC_JOB_CONFIG_TOKEN, useClass: BulkEEODataRequestAsyncJob, multi: true },
        {
          provide: ASYNC_JOB_CONFIG_TOKEN,
          useClass: BulkCompaniesCreateInvitationsAsyncJob,
          multi: true,
        },
        { provide: ASYNC_JOB_CONFIG_TOKEN, useClass: RemoveSampleDataAsyncJob, multi: true },
        { provide: ASYNC_JOB_CONFIG_TOKEN, useClass: GenerateSampleDataAsyncJob, multi: true },
      ],
    };
  }
}
